
class PageMetaTitle extends HTMLElement {

    static get observedAttributes(): string[] {
        return ['title'];
    }

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback(): void {
        this.updateTitle();
    }

    attributeChangedCallback(_name: string, oldValue: string | null, newValue: string | null): void {
        if (oldValue !== newValue) {
            this.updateTitle();
        }
    }

    get title(): string {
        return this.getAttribute('title') || '';
    }

    private updateTitle(): void {
        const title = this.title;
        if (title) {
            document.title = title; // Update the document title
        }
    }
}

customElements.define('page-meta-title', PageMetaTitle);
